import React from 'react';
import Icon from '../../../components/AppIcon';

const BookingInfoCards = () => {
  const infoCards = [
    {
      icon: 'Shield',
      iconColor: 'text-primary',
      bgColor: 'bg-primary/10',
      title: 'Secure & Private',
      description: 'All sessions are encrypted end-to-end with HIPAA-compliant security standards'
    },
    {
      icon: 'Clock',
      iconColor: 'text-secondary',
      bgColor: 'bg-secondary/10',
      title: 'Flexible Scheduling',
      description: 'Easy rescheduling and cancellation options with automatic notifications'
    },
    {
      icon: 'HeadphonesIcon',
      iconColor: 'text-accent',
      bgColor: 'bg-accent/10',
      title: '24/7 Support',
      description: 'Technical assistance and crisis resources available around the clock'
    }
  ];

  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
      {infoCards?.map((card, index) => (
        <div key={index} className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-start gap-4">
            <div className={`w-12 h-12 rounded-lg ${card?.bgColor} flex items-center justify-center flex-shrink-0`}>
              <Icon name={card?.icon} size={24} className={card?.iconColor} />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-foreground mb-2">{card?.title}</h3>
              <p className="text-sm text-muted-foreground">{card?.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BookingInfoCards;